<template>
  <transition name="fade" mode="out-in">
    <SharedIconButton v-if="show" variant="accent" @click="scrollToTop" :aria-label="t('goToTop.label')" :title="t('goToTop.label')" :aria-hidden="false" shadow>
      <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
        <path d="M5.707 3.828V13.414H7.707V3.828L12 8.121L13.414 6.707L6.707 0L0 6.707L1.414 8.121L5.707 3.828Z" fill="currentColor" />
      </svg>
    </SharedIconButton>
  </transition>
</template>

<script lang="ts" setup>
  const { t } = useI18n();
  const { y } = useWindowScroll();
  const show = ref(false);

  watch(y, () => {
    show.value = y.value > 100;
  });

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };
</script>

<style lang="scss" scoped></style>
